import React from 'react';
const C = { teal:'#00B4D8', success:'#10B981', dark:'#1F2937', grey:'#6B7280', border:'#E5E7EB' };

export default function StatCard({ title, value, icon: Icon, color, prefix='', suffix='', trend, loading }) {
  if (loading) return (
    <div className="card" style={{ padding: 24 }}>
      <div className="skeleton" style={{ height: 16, width: '60%', marginBottom: 12 }} />
      <div className="skeleton" style={{ height: 36, width: '40%' }} />
    </div>
  );
  return (
    <div className="card" style={{ padding: 24, display: 'flex', flexDirection: 'column', gap: 8 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span style={{ fontSize: 13, fontWeight: 500, color: C.grey }}>{title}</span>
        {Icon && (
          <div style={{ width: 40, height: 40, borderRadius: 10, background: (color||C.teal)+'18', display:'flex', alignItems:'center', justifyContent:'center' }}>
            <Icon style={{ width: 20, height: 20, color: color||C.teal }} />
          </div>
        )}
      </div>
      <div style={{ fontSize: 32, fontWeight: 800, color: color||C.dark, lineHeight: 1 }}>
        {prefix}{typeof value === 'number' ? value.toLocaleString() : (value || '—')}{suffix}
      </div>
      {trend !== undefined && (
        <div style={{ fontSize: 12, color: trend >= 0 ? C.success : '#EF4444', fontWeight: 500 }}>
          {trend >= 0 ? '↑' : '↓'} {Math.abs(trend)}% vs last month
        </div>
      )}
    </div>
  );
}
